<script lang="ts">
    import { onMount, tick } from 'svelte'
    import type { Invoice } from '../../../modules/posApi/invoices/invoice'
    import Zflow from '../../_common/z/zflow.svelte'
    import Zgrid from '../../_common/z/zgrid.svelte'
    import { GridClass, GridCol, GridColTypeEnum, GridLine, GridToggle, GridZInput } from '../../_common/z/zgrid'
    import Content from '../../_common/content.svelte'
    import type { Setting, SettingConfig } from '../../../modules/eventsApi/settings/setting'
    import Zframe from '../../_common/z/zframe.svelte'
    import ImagePic from '../../_common/ImagePic.svelte'

    let cmd: string = ''
    let value: string = ''
    let success: string = ''

    async function read() {
        value = await window.flags(cmd, false)
        console.log('value readed from ' + cmd, value)
    }

    async function write() {
        if (cmd === 'balance') return await recalcBalance()
        await window.flags(cmd, false, value)
        success = 'Salvo.'
        setTimeout(() => (success = ''), 3000)
    }

    async function recalcBalance() {
        const data: Invoice[] = await window.api.pos.invoices.getAll({
            from: new Date('1970-01-01'),
            to: new Date(),
            limit: 999999,
            service: false,
            payment: false,
        })
        const ids = [...new Set(data.map((el) => el.personId))]
        await window.api.pos.balanceResults.recalcBalance(ids)
        window.alert('Comando enviado para ' + ids.length + ' pessoas.')
    }

    onMount(async () => {
        await loadOptions()
    })

    let configs: SettingConfig = null
    async function loadOptions() {
        const settings = await window.api.events.settings.getConfigs()
        configs = settings.configs
        console.log('settings', configs)
        await loadGrid()
    }

    async function set(key: string, value: boolean, refresh: boolean = false) {
        console.log('option', key, value)
        let dto = {}
        dto[key] = value
        await window.api.events.settings.updateConfigs(dto)
        if (refresh) {
            location.reload()
        }
    }

    let grid: GridClass = new GridClass()
    // prettier-ignore
    async function loadGrid() {
        let options:{refresh:boolean, type: 'boolean' | 'array' | 'multiselect', key: string,  label: string, value: any, options?: any[], help?: string}[] = []
        //////////////////
        //////////////////

        options.push({refresh: false, type: 'boolean', key: 'allowPersonDuplicity', label: 'Permitir várias pessoas/clientes com o mesmo número de telefone', value: configs.allowPersonDuplicity})
        options.push({refresh: false, type: 'boolean', key: 'allowCashier', label: 'Ativar caixa do PDV por usuário', value: configs.allowCashier})
        options.push({refresh: false, type: 'boolean', key: 'allowCashierStatus', label: 'Ativar abertura e fechamento de caixa', value: configs.allowCashierStatus})
        options.push({refresh: false, type: 'boolean', key: 'posCashierShowClosingTotals', label: 'Exibir totais no fechamento do caixa', value: configs.posCashierShowClosingTotals})
        options.push({refresh: false, type: 'boolean', key: 'posShowDetails', label: 'Exibir detalhamento de vendas no PDV', value: configs.posShowDetails})
        options.push({refresh: true, type: 'boolean', key: 'financialVersionLatest', label: 'Utilizar versão mais recente do Financeiro', value: configs.financialVersionLatest})
        options.push({refresh: false, type: 'boolean', key: 'quotationVersionLatest', label: 'Utilizar versão mais recente dos Orçamentos', value: configs.quotationVersionLatest})
        options.push({refresh: false, type: 'boolean', key: 'scheduleAutoCommitStatus', label: 'Registrar agendamento como "atendido" ao lançar no PDV', value: configs.scheduleAutoCommitStatus})
        options.push({refresh: false, type: 'boolean', key: 'scheduleOneClickAdd', label: 'Agendar com 1 clique', value: configs.scheduleOneClickAdd})
        options.push({refresh: false, type: 'boolean', key: 'schedulueOnlyWithBalanceOrNoValue', label: 'Agendar apenas serviços com saldo ou gratuitos', value: configs.schedulueOnlyWithBalanceOrNoValue, help: 'Esta configuração não sobrepõe as configurações de agendamento online no aplicativo do cliente.'})
        options.push({refresh: false, type: 'multiselect', key: 'personRegisterRequired', options:[{value:'e-mail', label: 'e-mail'}, {value:'origem', label: 'origem'}], label: 'Cadastro de pessoa - campos obrigatórios', value: configs.personRegisterRequired})
        options.push({refresh: false, type: 'multiselect', key: 'posRequired', options:[{value:'e-mail', label: 'e-mail'}, {value:'origem', label: 'origem'}, {value:'endereco', label: 'endereço'}, {value:'document', label: 'documento'}], label: 'Lançamento de Venda - campos obrigatórios', value: configs.posRequired})
        options.push({refresh: true, type: 'array', key:'currency', options: window.api.utils.utils.getCurrency(), label: 'Moeda', value: configs.currency})
        options.push({refresh: false, type: 'boolean', key: 'financialShowAccrual', label: 'Ativar lançamentos financeiros por Competência (avançado)', value: configs.financialShowAccrual})
        options.push({refresh: false, type: 'boolean', key: 'documentVersionLatest', label: 'Utilizar a versão mais recente dos Documentos (Atendimento)', value: configs.documentVersionLatest})
        options.push({refresh: false, type: 'boolean', key: 'posPrintVersionLatest', label: 'Imprimir no PDV aciona nova versão dos Documentos', value: configs.posPrintVersionLatest})
        
        

        //////////////////
        //////////////////
        // grid
        // grid head
        grid.showActs = false
        grid.title = 'Configurações gerais'
        //grid.subtitle = ''
        grid.cols.push(new GridCol({ content: 'Recurso', size:5 }))
        grid.cols.push(new GridCol({ content: 'Status', type: GridColTypeEnum.zinput, size: 2}))

        // grid lines
        for (const option of options) {
            let line: GridLine = new GridLine()
            line.slots.push({ content: option.label })
            if (option.type === 'boolean') {
                line.slots.push({content: new GridZInput({callback: (c) => {set(option.key, c, option.refresh)},   value: option.value, type: 'toggle'})})
            }
            if (option.type === 'array') {
                line.slots.push({content: new GridZInput({callback: (c) => {set(option.key, c, option.refresh)},  options: option.options,  value: option.value, type: 'select'})})
            }
            if (option.type === 'multiselect') {
                line.slots.push({content: new GridZInput({callback: (c) => {set(option.key, c, option.refresh)},  options: option.options,  value: option.value, type: 'multiselect'})})
            }
            grid.lines.push(line)    
        }
        grid = grid
    }

    let base64
</script>

<Content>
    <Zflow>
        <Zgrid class="mt-3" {grid}></Zgrid>
        <Zframe title="Linha de Comando" headline="Linha de comando para configurações específicas via suporte ao cliente.">
            {#if window.beta}
                <!-- <div class="row">
                    <div class="col">
                        
                    </div>
                </div> -->
            {/if}

            <div class="cmd mt-3">
                <div class="input-group input-group-sm">
                    <label for="" class="input-group-text">Comando</label>
                    <input type="text" bind:value={cmd} class="form-control" />
                    <div class="btn btn-secondary" on:click={read}>&nbsp;&nbsp;&nbsp;&nbsp;ler&nbsp;&nbsp;&nbsp;&nbsp;</div>
                    <label for="" class="input-group-text">Valor</label>
                    <input type="text" bind:value class="form-control" />
                    <div class="btn btn-secondary" on:click={write}>&nbsp;&nbsp;salvar&nbsp;&nbsp;</div>
                </div>
                <div class="text-center">{success}&nbsp;</div>
            </div>
        </Zframe>
    </Zflow>
</Content>

<style>
    .intro-label {
        opacity: 0.8;
        font-weight: 300;
    }
    .cmd {
        padding: 30px 150px;
        opacity: 0.5;
    }

    .width-fixed {
        width: 100px;
    }
</style>
